module.exports = __webpack_public_path__ + "884fea100a2553b246b58b803ef03089.MP3";